import type { GA4ChatbotEventParams } from 'presentation/events/types/ga4Types';
import { getStoreIdAndStateId } from 'shared/custom/utils/cookieHandler';
import { GA4_BOT_CHANNEL_WEB, NOT_AVAILABLE } from './constants';
import { getDibotSessionId } from './sessionId';

export const buildChatbotEventParams = ({
	isChatbotEvent,
}: {
	isChatbotEvent?: boolean;
}): GA4ChatbotEventParams => {
	if (!isChatbotEvent) return { chatbot_event: 'false' };

	const { stLocId } = getStoreIdAndStateId();

	return {
		chatbot_event: 'true',
		session_id: getDibotSessionId() ?? NOT_AVAILABLE,
		store_id: stLocId ?? NOT_AVAILABLE,
		channel: GA4_BOT_CHANNEL_WEB,
	};
};
